import React, { Component } from 'react';
import {
  Button,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  Row,
  Table } from 'reactstrap';

class AutopayModal extends Component {
  render() {

    return (
      <Modal isOpen={this.props.isOpen} toggle={this.props.toggle} size="md">
        <ModalHeader className="no-border" toggle={this.props.toggle}>Manage Autopay</ModalHeader>
        <Table className="mb-0" size="sm" responsive striped borderless>
          <tbody>
            <tr>
              <th scope="row" className="pl-3">Frequency</th>
              <td className="text-right pr-3">Monthly (Every 8th)</td>
            </tr>
            <tr>
              <th scope="row" className="pl-3">Next Date</th>
              <td className="text-right pr-3">September 9, 2019</td>
            </tr>
            <tr>
              <th scope="row" className="pl-3">Pay From</th>
              <td className="text-right pr-3"><strong>Chase Bank</strong> ending 1234</td>
            </tr>
            <tr>
              <th scope="row" className="pl-3">Pay Amount</th>
              <td className="text-right pr-3"><strong>$300.00</strong></td>
            </tr>
          </tbody>
        </Table>
        <ModalBody>
          <Row>
            <Col>
              <Button size="sm" className="w-100">Edit Payment</Button>
            </Col>
            <Col>
              <Button size="sm" className="w-100">Cancel Autopay</Button>
            </Col>
          </Row>
        </ModalBody>
      </Modal>
    );
  }
}

export default AutopayModal;
